import { useEffect, useRef } from 'react';
import { useMessengerV2ControllerContext } from '../messenger-v2/MessengerV2ControllerContext';
import { useRoomInbox } from './RoomInboxContext';

const shouldRetireConversation = (event) => {
  const kind = String(event?.kind || '');
  if (kind === 'membership_revoked' || kind === 'room_deleted') return true;
  return kind === 'room_archived' && event?.archivedChatEnabled !== true;
};

export const RoomConversationLifecycleBridge = () => {
  const controller = useMessengerV2ControllerContext();
  const { lifecycleEvent } = useRoomInbox();
  const handledVersionRef = useRef(0);

  useEffect(() => {
    const version = Number(lifecycleEvent?.version) || 0;
    const conversationId = lifecycleEvent?.conversationId;
    if (
      version <= handledVersionRef.current ||
      !conversationId ||
      !shouldRetireConversation(lifecycleEvent)
    ) {
      return;
    }

    handledVersionRef.current = version;
    controller?.hideThreadConversation?.({ conversationId: String(conversationId) });
    if (String(controller?.state?.activeConversationId || '') === String(conversationId)) {
      controller?.setSurfaceConversationId?.(null);
    }
  }, [controller, lifecycleEvent]);

  return null;
};

export default RoomConversationLifecycleBridge;
